<template>
  <div>
    <div class="test" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave"
      :class="{ 'is-hidden': !isExpanded }">
      <el-badge :value="alarmNum > 99 ? '99+' : alarmNum" :hidden="alarmNum === 0" class="item cursor-pointer"
        @click="openNotification">
        <svg style="transform: scale(1.5)" v-if="false" width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <!-- 动画铃铛 -->
          <g transform-origin="center">
            <animateTransform attributeName="transform" type="rotate" values="0; -20; 0; 20; 0" dur="1s"
              repeatCount="indefinite" />
            <path
              d="M12 3C10.4087 3 8.88258 3.63214 7.75736 4.75736C6.63214 5.88258 6 7.4087 6 9V13.586L4.293 15.293C4.16835 15.4176 4.07915 15.5731 4.03431 15.7433C3.98947 15.9135 3.99062 16.0923 4.03766 16.2619C4.0847 16.4315 4.17588 16.5857 4.30192 16.7083C4.42796 16.831 4.58412 16.9176 4.755 16.959C4.92588 17.0004 5.10534 16.9949 5.273 16.943C5.44066 16.8911 5.59054 16.7948 5.707 16.664L7.414 14.828C7.448 14.79 7.486 14.756 7.521 14.72C7.556 14.684 7.59 14.646 7.628 14.612V9C7.628 7.93913 8.04943 6.92172 8.79959 6.17157C9.54974 5.42143 10.5671 5 11.628 5H12.372C13.4329 5 14.4503 5.42143 15.2004 6.17157C15.9506 6.92172 16.372 7.93913 16.372 9V14.612C16.41 14.646 16.444 14.684 16.479 14.72C16.514 14.756 16.552 14.79 16.586 14.828L18.293 16.664C18.4095 16.7948 18.5593 16.8911 18.727 16.943C18.8947 16.9949 19.0741 17.0004 19.245 16.959C19.4159 16.9176 19.572 16.831 19.6981 16.7083C19.8241 16.5857 19.9153 16.4315 19.9623 16.2619C20.0094 16.0923 20.0105 15.9135 19.9657 15.7433C19.9208 15.5731 19.8316 15.4176 19.707 15.293L18 13.586V9C18 7.4087 17.3679 5.88258 16.2426 4.75736C15.1174 3.63214 13.5913 3 12 3Z"
              :fill="alarmNum > 0 ? '#FF5252' : '#909399'" />
            <path d="M12 21C13.1046 21 14 20.1046 14 19H10C10 20.1046 10.8954 21 12 21Z"
              :fill="alarmNum > 0 ? '#FF5252' : '#909399'" />
          </g>
        </svg>
        <svg style="transform: scale(1.5)" v-else width="24" height="24" viewBox="0 0 24 24" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 3C10.4087 3 8.88258 3.63214 7.75736 4.75736C6.63214 5.88258 6 7.4087 6 9V13.586L4.293 15.293C4.16835 15.4176 4.07915 15.5731 4.03431 15.7433C3.98947 15.9135 3.99062 16.0923 4.03766 16.2619C4.0847 16.4315 4.17588 16.5857 4.30192 16.7083C4.42796 16.831 4.58412 16.9176 4.755 16.959C4.92588 17.0004 5.10534 16.9949 5.273 16.943C5.44066 16.8911 5.59054 16.7948 5.707 16.664L7.414 14.828C7.448 14.79 7.486 14.756 7.521 14.72C7.556 14.684 7.59 14.646 7.628 14.612V9C7.628 7.93913 8.04943 6.92172 8.79959 6.17157C9.54974 5.42143 10.5671 5 11.628 5H12.372C13.4329 5 14.4503 5.42143 15.2004 6.17157C15.9506 6.92172 16.372 7.93913 16.372 9V14.612C16.41 14.646 16.444 14.684 16.479 14.72C16.514 14.756 16.552 14.79 16.586 14.828L18.293 16.664C18.4095 16.7948 18.5593 16.8911 18.727 16.943C18.8947 16.9949 19.0741 17.0004 19.245 16.959C19.4159 17.0004 19.572 16.831 19.6981 16.7083C19.8241 16.5857 19.9153 16.4315 19.9623 16.2619C20.0094 16.0923 20.0105 15.9135 19.9657 15.7433C19.9208 15.5731 19.8316 15.4176 19.707 15.293L18 13.586V9C18 7.4087 17.3679 5.88258 16.2426 4.75736C15.1174 3.63214 13.5913 3 12 3Z"
            :fill="alarmNum > 0 ? '#FF5252' : '#909399'" />
          <path d="M12 21C13.1046 21 14 20.1046 14 19H10C10 20.1046 10.8954 21 12 21Z"
            :fill="alarmNum > 0 ? '#FF5252' : '#909399'" />
        </svg>
      </el-badge>
      <el-dialog v-model="dialogVisible" :title="$t('alarm.alarmMessage')" width="60%" :before-close="handleClose">
        <common-table class="mb-4" :dataList="currentDataList" :colConfigs="colConfigs"
          :dataListLoading="state.dataListLoading" :current-page="state.pageNum" :page-size="state.pageSize">
          <template v-slot:operation>
            <el-table-column v-if="checkPermi(['system:alarmsTemplate:query'])" :label="$t('common.operate')" fixed="right"
              width="110px">
              <template v-slot="scope">
                <table-action :actionList="state.actionList" :rowInfo="scope.row" @formAction="rest.operationHandle" />
              </template>
            </el-table-column>
          </template>
        </common-table>
        <el-pagination v-if="alarmNum > 0" v-model:current-page="state.pageNum" v-model:page-size="state.pageSize"
          :page-sizes="[5, 10, 20, 50]" :background="true" layout="total, sizes, prev, pager, next" :total="alarmNum"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        <template v-slot:footer>
          <div class="dialog-footer">
            <el-button type="primary" @click="handleClose">{{
              $t("common.confirm")
              }}</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script setup lang="ts">
import { checkPermi } from "@/utils/permission";
import useList from "@/hooks/useList";
import { ref, onMounted, computed, onUnmounted } from "vue";
import { initMqtt, mqttReceive } from "../../utils/mqtt";
import { useRouter } from "vue-router";
import { listAlarmsTemplate } from "@/api/system/alarm";
import useUserStore from "@/store/modules/user.js";
import dayjs from "dayjs";

const ringing = ref(false);
const alarmNum = ref(0);
const dialogVisible = ref(false);
const alarmList = ref([]);

// ========== 新增：自动贴边隐藏相关 ==========
const isExpanded = ref(true);          // 是否展开（完全显示）
const isHovering = ref(false);         // 鼠标是否悬停
let hideTimer: ReturnType<typeof setTimeout> | null = null;

// 清除隐藏定时器
const clearHideTimer = () => {
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
};

// 启动隐藏定时器（5秒后贴边）
const startHideTimer = () => {
  clearHideTimer();
  // 只有对话框未打开且鼠标不在元素上时才启动
  if (!dialogVisible.value && !isHovering.value) {
    hideTimer = setTimeout(() => {
      isExpanded.value = false;
    }, 1000);
  }
};

// 展开按钮（清除定时器并强制展开）
const show = () => {
  clearHideTimer();
  isExpanded.value = true;
};

// 鼠标进入
const handleMouseEnter = () => {
  isHovering.value = true;
  show();
};

// 鼠标离开
const handleMouseLeave = () => {
  isHovering.value = false;
  startHideTimer();
};
// ===========================================

// const dicts: any = ref({
//   alarm_code: [],
//   alarm_type: [],
//   alarm_level: [],
//   alarm_entity_type: [],
//   alarm_reason: [],
// });
// listAlarmsTemplate({ pageSize: 9999, pageNum: 1 }).then((res) => {
//   // dicts.value.alarm_level = res.rows.map((item) => ({
//   //   value: item.severity,
//   //   label: item.severityDisplay,
//   // }));
//   // dicts.value.alarm_entity_type = res.rows.map((item) => ({
//   //   value: item.entityType,
//   //   label: item.entityTypeDisplay,
//   // }));
// });

const tableConfig = (optionDict) => [
  {
    label: "alarm.deviceName",
    prop: "deviceName",
    align: "center",
    width: "130px",
    // options: optionDict.alarm_code,
  },
  {
    label: "alarm.alarmMessage",
    prop: "alarmInfo",
    align: "center",
    width: "180px",
    // options: optionDict.alarm_code,
  },
  {
    label: "alarm.severity",
    prop: "severityDisplay",
    align: "center",
    width: "130px",
    // options: optionDict.alarm_level,
  },

  {
    label: "alarm.reasonDescription",
    prop: "reason",
    align: "center",
    width: "180px",
    // options: optionDict.alarm_reason,
  },

  {
    label: "alarm.alarmRealTime",
    prop: "alarmStartTime",
    width: "180px",
    align: "center",
    render: (row: any) => {
      return dayjs.unix(row.alarmStartTime).format("YYYY-MM-DD HH:mm:ss");
    },
  },
  { label: "common.operation", slot: "operation" },
];
const colConfigs = computed(() => tableConfig([]));

const { state, ...rest } = useList({
  dataForm: {},
  getListApi: undefined,
});

const currentDataList = computed(() =>
  alarmList.value.slice(
    (state.value.pageNum - 1) * state.value.pageSize,
    state.value.pageNum * state.value.pageSize
  )
);

function handleCurrentChange(currentPage: number) {
}
function handleSizeChange(currentPage: number) {
}

const router = useRouter();

onMounted(() => {
  initMqtt(useUserStore().tenantId, useUserStore().id);
  mqttReceive({
    setAlarmNum: (num: number) => (alarmNum.value += num),
    setAlarmList: (list: any[]) =>
      (alarmList.value = alarmList.value.concat(list)),
  });
  state.value.actionList = [
    {
      name: "alarm.jump",
      hasPermi: ['system:alarmsTemplate:query'],
      methods: async (row: {
        deviceSn: string;
        devSn: string;
        deviceName: string;
      }) => {
        router.push({
          path: "/devmonitor/alarmHistory",
          query: {
            devSn: row?.devSn || row?.deviceSn,
            deviceName: row?.deviceName,
          },
        });
        handleClose();
      },
    },
  ];

  // 组件挂载后启动隐藏定时器（初始5秒后贴边）
  startHideTimer();
});

// 组件卸载时清除定时器
onUnmounted(() => {
  clearHideTimer();
});

// 修改 openNotification：打开对话框时强制展开
function openNotification() {
  show(); // 展开并清除隐藏定时器
  dialogVisible.value = true;
  ringing.value = true;
}

// 修改 handleClose：关闭对话框后重新启动隐藏定时器
function handleClose() {
  alarmNum.value = 0;
  alarmList.value = [];
  dialogVisible.value = false;
  ringing.value = false;
  // 若鼠标不在元素上，则启动隐藏定时器
  if (!isHovering.value) {
    startHideTimer();
  }
}
</script>

<style lang="scss" scoped>
.test {
  position: fixed;
  right: 30px;
  z-index: 9;
  bottom: 30px;
  background-color: rgba($color: #ffffff, $alpha: 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #888888;
  border-radius: 10px;
  box-sizing: border-box;
  width: 50px;
  height: 50px;
  transition: transform 0.3s ease; // 平滑滑动

  &.is-hidden {
    // 向右平移自身宽度 + 20px（原 right:30px，目标露出 10px => 30-10=20）
    transform: translateX(calc(100% + 20px));
  }
}
</style>